(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vk2-anatomy-scroll-build"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionSelector = '[data-vk2-anatomy]';
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialiseSection = (section) => {
    if (!section || section.dataset.vk2AnatomyInitialised === 'true') return;

    const scrollArea = section.querySelector('[data-vk2-anatomy-scroll]');
    const controls = Array.from(section.querySelectorAll('[data-vk2-anatomy-control]'));
    const layers = Array.from(section.querySelectorAll('[data-vk2-anatomy-layer]'));
    const details = Array.from(section.querySelectorAll('[data-vk2-anatomy-details]'));

    if (!scrollArea || !controls.length || controls.length !== layers.length) return;

    section.dataset.vk2AnatomyInitialised = 'true';

    let activeIndex = 0;
    let isExpanded = false;
    let scrollFrame;

    const setLayerOffsets = () => {
      const separation = Number.parseFloat(getComputedStyle(section).getPropertyValue('--vk2-layer-separation')) || 120;
      const stage = isExpanded ? Math.min(activeIndex + 1, layers.length - 1) : 0;

      layers.forEach((layer) => {
        const layerIndex = Number.parseInt(layer.dataset.index, 10);
        const stepsAway = Math.max(0, stage - layerIndex);
        layer.style.setProperty('--vk2-layer-offset', `${-stepsAway * separation}px`);
      });
    };

    const setExpanded = (nextExpanded) => {
      isExpanded = nextExpanded;
      section.classList.toggle('vk2-anatomy--assembled', !isExpanded);
      section.classList.toggle('vk2-anatomy--expanded', isExpanded);
      setLayerOffsets();
    };

    const setActive = (index) => {
      const nextIndex = Math.max(0, Math.min(index, controls.length - 1));
      activeIndex = nextIndex;

      controls.forEach((control, controlIndex) => {
        const isActive = controlIndex === nextIndex;
        control.classList.toggle('is-active', isActive);
        control.setAttribute('aria-pressed', String(isActive));
      });

      layers.forEach((layer) => {
        const layerIndex = Number.parseInt(layer.dataset.index, 10);
        const isActive = layerIndex === nextIndex;
        layer.classList.toggle('is-active', isActive);
        layer.setAttribute('aria-hidden', String(!isActive));
      });

      setLayerOffsets();
    };

    const updateFromScroll = () => {
      scrollFrame = undefined;
      if (!desktopQuery.matches) return;

      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      const travelDistance = Math.max(1, scrollArea.offsetHeight - window.innerHeight);
      const rawProgress = (window.scrollY - sectionTop) / travelDistance;
      const progress = Math.max(0, Math.min(1, rawProgress));
      const nextIndex = Math.round(progress * (controls.length - 1));

      setExpanded(progress > 0.001);

      if (nextIndex !== activeIndex) setActive(nextIndex);
    };

    const queueScrollUpdate = () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(updateFromScroll);
    };

    const scrollToStep = (index) => {
      if (!desktopQuery.matches) return;

      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      const travelDistance = Math.max(1, scrollArea.offsetHeight - window.innerHeight);
      const targetProgress = Math.max(0.002, controls.length > 1 ? index / (controls.length - 1) : 0);
      const targetTop = sectionTop + (travelDistance * targetProgress);

      window.scrollTo({
        top: targetTop,
        behavior: reduceMotionQuery.matches ? 'auto' : 'smooth'
      });
    };

    controls.forEach((control, index) => {
      control.addEventListener('click', () => {
        setExpanded(true);
        setActive(index);
        scrollToStep(index);
      });
    });

    details.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open || desktopQuery.matches) return;
        details.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });

    window.addEventListener('scroll', queueScrollUpdate, { passive: true });
    window.addEventListener('resize', queueScrollUpdate, { passive: true });
    desktopQuery.addEventListener('change', queueScrollUpdate);

          setActive(0);
      setLayerOffsets();
      queueScrollUpdate();

  };

  const initialiseAll = (scope = document) => {
    if (scope.matches && scope.matches(sectionSelector)) {
      initialiseSection(scope);
    }

    scope.querySelectorAll(sectionSelector).forEach(initialiseSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vk2-colorways"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionSelector = '[data-vk2-colorways]';

  const initialiseSection = (section) => {
    if (!section || section.dataset.vk2ColorwaysInitialised === 'true') return;

    const options = Array.from(section.querySelectorAll('[data-vk2-colorway-option]'));
    const images = Array.from(section.querySelectorAll('[data-vk2-colorway-image]'));
    const panels = Array.from(section.querySelectorAll('[data-vk2-colorway-panel]'));
    const mensLink = section.querySelector('[data-vk2-colorway-mens-link]');
    const womensLink = section.querySelector('[data-vk2-colorway-womens-link]');

    if (!options.length || options.length !== images.length || !mensLink || !womensLink) return;

    section.dataset.vk2ColorwaysInitialised = 'true';

    const setActive = (index, focus = false) => {
      const nextIndex = Math.max(0, Math.min(index, options.length - 1));
      const activeOption = options[nextIndex];

      options.forEach((option, optionIndex) => {
        const isActive = optionIndex === nextIndex;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-selected', String(isActive));
        option.tabIndex = isActive ? 0 : -1;
      });

      images.forEach((image, imageIndex) => {
        const isActive = imageIndex === nextIndex;
        image.classList.toggle('is-active', isActive);
        image.setAttribute('aria-hidden', String(!isActive));
      });

      panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== nextIndex;
      });

      mensLink.href = activeOption.dataset.mensUrl || '#';
      womensLink.href = activeOption.dataset.womensUrl || '#';
      mensLink.setAttribute('aria-label', `${section.dataset.mensLabel || 'Shop men’s'}: ${activeOption.dataset.colorwayName || ''}`);
      womensLink.setAttribute('aria-label', `${section.dataset.womensLabel || 'Shop women’s'}: ${activeOption.dataset.colorwayName || ''}`);

      if (focus) activeOption.focus();
    };

    options.forEach((option, index) => {
      option.addEventListener('click', () => setActive(index));

      option.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % options.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + options.length) % options.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = options.length - 1;

        if (nextIndex !== null) {
          event.preventDefault();
          setActive(nextIndex, true);
        }
      });
    });

    setActive(0);
  };

  const initialiseAll = (scope = document) => {
    if (scope.matches && scope.matches(sectionSelector)) {
      initialiseSection(scope);
    }

    scope.querySelectorAll(sectionSelector).forEach(initialiseSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vk2-spec-readout"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionSelector = '[data-vk2-spec-readout]';
  const counterSelector = '[data-vk2-counter]';

  const initialiseSection = (section) => {
    if (!section || section.dataset.vk2CounterInitialised === 'true') return;

    const counter = section.querySelector(counterSelector);
    if (!counter) return;

    const target = Number(counter.dataset.counterValue);
    const decimals = Math.max(0, Math.min(3, Number(counter.dataset.counterDecimals) || 0));
    const duration = Math.max(0, Number(section.dataset.counterDuration) || 1200);
    const replay = section.dataset.counterReplay === 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!Number.isFinite(target)) return;

    section.dataset.vk2CounterInitialised = 'true';

    const formatValue = (value) => value.toFixed(decimals);
    const finalValue = formatValue(target);
    let animationFrame;
    let hasPlayed = false;

    const render = (value) => {
      counter.textContent = formatValue(value);
    };

    const animate = () => {
      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
      }

      if (reduceMotion || duration === 0) {
        counter.textContent = finalValue;
        hasPlayed = true;
        return;
      }

      const startTime = window.performance.now();

      const step = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);

        render(target * easedProgress);

        if (progress < 1) {
          animationFrame = window.requestAnimationFrame(step);
        } else {
          counter.textContent = finalValue;
          animationFrame = undefined;
          hasPlayed = true;
        }
      };

      animationFrame = window.requestAnimationFrame(step);
    };

    render(0);

    if (!('IntersectionObserver' in window) || reduceMotion) {
      animate();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || (hasPlayed && !replay)) return;

          animate();

          if (!replay) {
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.2
      }
    );

    observer.observe(section);
  };

  const initialiseAll = (scope = document) => {
    if (scope.matches && scope.matches(sectionSelector)) {
      initialiseSection(scope);
    }

    scope.querySelectorAll(sectionSelector).forEach(initialiseSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vk2-text-marquee"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionSelector = '[data-vk2-marquee]';
  const trackSelector = '[data-vk2-marquee-track]';
  const sequenceSelector = '[data-vk2-marquee-sequence]';

  const initialiseSection = (section) => {
    if (!section || section.dataset.vk2MarqueeInitialised === 'true') return;

    const viewport = section.querySelector('.vk2-text-marquee__viewport');
    const track = section.querySelector(trackSelector);
    const sourceSequence = section.querySelector(sequenceSelector);
    const hasLinkedBlocks = section.dataset.hasLinkedBlocks === 'true';
    const desktopPointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    if (!viewport || !track || !sourceSequence) return;

    section.dataset.vk2MarqueeInitialised = 'true';

    let renderFrame;

    const removeClones = () => {
      track.querySelectorAll('.vk2-text-marquee__sequence--clone').forEach((clone) => clone.remove());
    };

    const createClone = () => {
      const clone = sourceSequence.cloneNode(true);
      clone.classList.add('vk2-text-marquee__sequence--clone');
      clone.removeAttribute('data-vk2-marquee-sequence');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((item) => {
        item.removeAttribute('data-shopify-editor-block');
      });
      clone.querySelectorAll('[data-vk2-marquee-link]').forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
      return clone;
    };

    const setLinkHovered = (isHovered) => {
      const canPauseOnHover = hasLinkedBlocks && desktopPointerQuery.matches;
      section.dataset.vk2LinkHovered = String(canPauseOnHover && isHovered);
    };

    const setLinkFocused = (isFocused) => {
      section.dataset.vk2LinkFocused = String(isFocused);
    };

    const render = () => {
      removeClones();

      const sequenceWidth = Math.ceil(sourceSequence.getBoundingClientRect().width);
      const viewportWidth = Math.ceil(viewport.getBoundingClientRect().width);

      if (!sequenceWidth || !viewportWidth) return;

      const cloneCount = Math.max(1, Math.ceil(viewportWidth / sequenceWidth) + 1);

      for (let index = 0; index < cloneCount; index += 1) {
        track.appendChild(createClone());
      }

      track.style.setProperty('--vk2-loop-distance', `-${sequenceWidth}px`);
    };

    const queueRender = () => {
      window.cancelAnimationFrame(renderFrame);
      renderFrame = window.requestAnimationFrame(render);
    };

    const handleLinkPointerOver = (event) => {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('[data-vk2-marquee-link]');
      if (link && section.contains(link)) {
        setLinkHovered(true);
      }
    };

    const handleLinkPointerOut = (event) => {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('[data-vk2-marquee-link]');
      const nextTarget = event.relatedTarget;

      if (link && (!nextTarget || !link.contains(nextTarget))) {
        setLinkHovered(false);
      }
    };

    const handleFocusIn = (event) => {
      if (event.target.matches('[data-vk2-marquee-link]')) {
        setLinkFocused(true);
      }
    };

    const handleFocusOut = (event) => {
      const nextTarget = event.relatedTarget;

      if (!nextTarget || !section.contains(nextTarget)) {
        setLinkFocused(false);
      }
    };

    const handlePointerCapabilityChange = () => setLinkHovered(false);

    queueRender();

    if (hasLinkedBlocks) {
      viewport.addEventListener('pointerover', handleLinkPointerOver);
      viewport.addEventListener('pointerout', handleLinkPointerOut);
      section.addEventListener('focusin', handleFocusIn);
      section.addEventListener('focusout', handleFocusOut);

      if (desktopPointerQuery.addEventListener) {
        desktopPointerQuery.addEventListener('change', handlePointerCapabilityChange);
      } else if (desktopPointerQuery.addListener) {
        desktopPointerQuery.addListener(handlePointerCapabilityChange);
      }
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(queueRender);
      resizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', queueRender, { passive: true });
    }
  };

  const initialiseAll = (scope = document) => {
    if (scope.matches && scope.matches(sectionSelector)) {
      initialiseSection(scope);
    }

    scope.querySelectorAll(sectionSelector).forEach(initialiseSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
